const state = {
  extra_packaging: [],
  extra_packaging_id: [],
};

export default state;
